// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N1I6","rootMobile":"styles_rootMobile__26uxH"};